<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
       id="page-configure-temporary-password"
       v-if="cognitoUser">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/4 sm:m-0 m-4">
      <vx-card>
        <div class="full-page-bg-color" slot="no-body">

          <vs-row vs-type="flex" vs-w="12">
            <div class="vx-col flex sm:w-1 md:w-1 lg:w-full d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="pt-2">
                  <security-temporary-password-setup :cognito-user="cognitoUser" @updated="onUpdate" @error="onCancel">

                  </security-temporary-password-setup>
                  <vs-alert color="danger" :active="errorMessage" class="mt-5 mb-5">
                    You must update the temporary password in order to use your account. <a href="#" @click.prevent="onSignOut">Sign out</a>
                  </vs-alert>
                </div>
              </div>
            </div>
          </vs-row>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import {Auth} from 'aws-amplify';
import SecurityTemporaryPasswordSetup from '@/views/app/security/edit/security-temporary-password-setup.vue';

export default {
  name: 'configure-password-view',
  components: {
    SecurityTemporaryPasswordSetup
  },
  props: {
    cognitoUser: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      errorMessage: false
    };
  },
  methods: {
    onCancel () {
      Auth.signOut();
      this.$router.push({
        name: 'page-login'
      });
    },
    onSignOut () {
      Auth.signOut();
      this.$router.push({
        name: 'page-login'
      });
    },
    onUpdate (isConfigured) {
      if (!isConfigured) {
        this.errorMessage = true;
        return;
      }
      this.$router.push({name: 'app-dashboard'});
    }
  }
};
</script>
